import { Box, Grid2, Typography } from "@mui/material";
import { Gauge, gaugeClasses } from "@mui/x-charts/Gauge";
import React from "react";
import { HandleSkeletion } from "../../../../utils/constants";
import { CommonGrid2 } from "../../../common-components/StyledComponents";
import { CustomPaper } from "../../../resume-intelligence/Style";
import Comparison from "./Comparison";
import { CustomizeSpan, TooltipParagraph } from "../../style";

export default function SpiderGraph({
  matchedData,
  handleScoreChange,
  loading,
  matchSelected,
  disabled,
  getJustification,
  CustomTooltip,
  isLoading,
  checkWidth,
}) {
  return (
    <CustomPaper
      variant="outlined"
      width="100%"
      padding={"12px"}
      margin={"1rem 0px 0px"}
      height="100%"
    >
      <Grid2
        container
        justifyContent="center"
        spacing={2}
        height={"100%"}
        alignItems="stretch"
      >
        <Grid2
          item
          size={{
            xs: 12,
            md: checkWidth < 850 ? 12 : 6,
            sm: 12,
          }}
        >
          <Typography variant="h3" margin={"10px 0px 1rem"}>
            Matching Summary
          </Typography>
          {loading ? (
            Array.from({ length: 1 }).map((_, index) => (
              <HandleSkeletion height={100} width={100} marginRight={"1rem"} />
            ))
          ) : (
            <CommonGrid2
              item
              display={"flex"}
              size={{ xs: 12, md: 5, sm: 12 }}
              container
              justifyContent={"center"}
              spacing={1.5}
              alignItems={"center"}
              width={"100% !important"}
              flexDirection={"row"}
            >
              {matchedData?.match_summary &&
                [...Array(Math.ceil(matchedData.match_summary.length / 3))].map(
                  (_, rowIndex) => {
                    const rowItems = matchedData.match_summary.slice(
                      rowIndex * 3,
                      rowIndex * 3 + 3
                    );

                    return (
                      <CommonGrid2
                        key={rowIndex}
                        container
                        item
                        justifyContent={"center"}
                        spacing={1.5}
                        flexDirection="row"
                        marginBottom="10px"
                      >
                        {rowItems.map((item, index) => {
                          const color =
                            item.score >= 75
                              ? "#47CD89"
                              : item.score >= 30
                              ? "#FDB022"
                              : "red";

                          return (
                            <Box
                              display="flex"
                              flexDirection="column"
                              alignItems="center"
                              // mx={1.5}
                              sx={{
                                cursor: disabled ? "auto" : "pointer",
                                opacity:
                                  matchSelected.name === item.name
                                    ? 1
                                    : disabled
                                    ? 0.6
                                    : 1,
                              }}
                              border={
                                matchSelected.name === item.name &&
                                "1px solid #EAECEE"
                              }
                              borderRadius={"10px"}
                              onClick={() =>
                                disabled ? {} : handleScoreChange(item.name)
                              }
                              padding={
                                matchSelected.name === item.name
                                  ? "5px 10px"
                                  : "5px"
                              }
                              boxShadow={
                                matchSelected.name === item.name &&
                                "0px 1px 5px 0px rgb(116 58 235 / 43%)"
                              }
                            >
                              <Gauge
                                width={90}
                                height={90}
                                value={item.score}
                                cornerRadius="50%"
                                outerRadius="100%"
                                innerRadius="75%"
                                text={({ value, valueMax }) => `${item.score}%`}
                                sx={(theme) => ({
                                  [`& .${gaugeClasses.valueText}`]: {
                                    fontSize: 12,
                                    color: disabled ? "#98A2B3" : "#101828",
                                    fontWeight: 700,
                                  },
                                  [`& .${gaugeClasses.valueArc}`]: {
                                    fill: color,
                                  },
                                })}
                              />
                              <Typography
                                fontSize={"12px"}
                                color={"#475467"}
                                fontWeight={700}
                              >
                                {item.name}
                              </Typography>
                            </Box>
                          );
                        })}
                      </CommonGrid2>
                    );
                  }
                )}
            </CommonGrid2>
          )}

          <CommonGrid2
            item
            backgroundColor="#F5F6F7"
            borderRadius={"10px"}
            padding={"10px"}
            marginTop={"1rem"}
          >
            <CommonGrid2>
              {isLoading ? (
                <HandleSkeletion
                  height={20}
                  width={"40%"}
                  transform={"scale(1)"}
                />
              ) : (
                <Typography variant="h6" fontWeight={700}>
                  {getJustification?.name}
                </Typography>
              )}

              <CommonGrid2
                gap={"4px"}
                marginTop={"8px"}
                display={"flex"}
                flexDirection={"column"}
              >
                <TooltipParagraph
                  color={"#6941C6"}
                  display={"flex"}
                  justifyContent={"space-between"}
                  flexDirection={"row"}
                  gap="10px"
                  fontSize={"14px"}
                >
                  Candidate Score:{" "}
                  {isLoading ? (
                    <HandleSkeletion
                      height={20}
                      width={30}
                      transform={"scale(1)"}
                    />
                  ) : (
                    <TooltipParagraph fontWeight={700}>
                      {getJustification?.payload?.candidate_score || "-"}
                    </TooltipParagraph>
                  )}
                </TooltipParagraph>
                <TooltipParagraph
                  color={"#667085a1"}
                  display={"flex"}
                  justifyContent={"space-between"}
                  flexDirection={"row"}
                  gap="10px"
                  fontSize={"14px"}
                >
                  Highest Score:{" "}
                  {isLoading ? (
                    <HandleSkeletion
                      height={20}
                      width={30}
                      transform={"scale(1)"}
                    />
                  ) : (
                    <TooltipParagraph fontWeight={700}>
                      {getJustification?.payload?.highest_score || "-"}
                    </TooltipParagraph>
                  )}
                </TooltipParagraph>
                <TooltipParagraph
                  color={"#F79009"}
                  display={"flex"}
                  justifyContent={"space-between"}
                  flexDirection={"row"}
                  gap="10px"
                  fontSize={"14px"}
                >
                  Average Score:{" "}
                  {isLoading ? (
                    <HandleSkeletion
                      height={20}
                      width={30}
                      transform={"scale(1)"}
                    />
                  ) : (
                    <TooltipParagraph fontWeight={700}>
                      {getJustification?.payload?.average_score || "-"}
                    </TooltipParagraph>
                  )}
                </TooltipParagraph>
              </CommonGrid2>

              <Typography
                variant="h6"
                fontSize="14px"
                textAlign="justify"
                color="#00a6ff"
                fontWeight="700"
                marginTop={"5px"}
              >
                <CustomizeSpan
                  color="#0C111D"
                  fontSize="14px"
                  fontWeight="700"
                  textAlign="justify"
                >
                  Justification :{" "}
                  {isLoading ? (
                    <HandleSkeletion height={30} transform={"scale(1)"} />
                  ) : (
                    <CustomizeSpan fontWeight="600" fontSize="14px">
                      {getJustification?.title || "-"}
                    </CustomizeSpan>
                  )}
                </CustomizeSpan>
              </Typography>
            </CommonGrid2>
          </CommonGrid2>
        </Grid2>
        <Grid2
          item
          size={{ xs: 12, md: checkWidth < 850 ? 12 : 6, sm: 12 }}
          margin={"1rem 0px 2rem"}
          display="flex"
          flexDirection="column"
          flex={1}
        >
          <Comparison
            matchedData={matchedData}
            loading={loading}
            disabled={disabled}
            getJustification={getJustification}
            CustomTooltip={CustomTooltip}
          />
        </Grid2>
      </Grid2>
    </CustomPaper>
  );
}
